import { Heading, Text } from '@hungryroot/ramen';
import { type ProductWithDishTypes } from '../../api';

import styles from './DishTypes.module.css';

interface Props {
  testid?: string;
  product: Pick<ProductWithDishTypes, 'dish_types'>;
  link?: true;
}

function renderText(dishTypeTestId: string, text: string) {
  return (
    <Text className={styles.label} testid={dishTypeTestId}>
      {text}
    </Text>
  );
}

function renderImage(
  testid: string,
  profile_image_url: string | null,
  text: string
) {
  if (profile_image_url === null) {
    return null;
  }

  return (
    <img
      loading="lazy"
      className={styles.image}
      src={profile_image_url}
      alt={text}
      data-testid={testid}
    />
  );
}

export function DishTypes(props: Props) {
  const {
    product: { dish_types: dishTypes },
    testid,
    link,
  } = props;
  return (
    <section data-testid={testid} className={styles.section}>
      <Heading testid={`${testid}-title`} variant="H5">
        Try it in ...
      </Heading>
      <div className={styles.container}>
        {dishTypes.map((type) => {
          const { id: dishTypeId, profile_image_url, name_plural } = type;
          const dishTypeTestId = `${testid}-dishtype-${dishTypeId}`;
          if (link === true) {
            const url = `/recipes/?dishtype=${dishTypeId}`;
            return (
              <article
                className={styles.tile}
                key={dishTypeId}
                data-testid={dishTypeTestId}
              >
                <a
                  href={url}
                  className={styles.link}
                  data-testid={`${dishTypeTestId}-link`}
                >
                  {renderImage(
                    `${dishTypeTestId}-image`,
                    profile_image_url,
                    name_plural
                  )}
                  {renderText(`${dishTypeTestId}-label`, name_plural)}
                </a>
              </article>
            );
          }
          return (
            <article
              key={dishTypeId}
              data-testid={dishTypeTestId}
              className={styles.tile}
            >
              {renderImage(
                `${dishTypeTestId}-image`,
                profile_image_url,
                name_plural
              )}
              {renderText(`${dishTypeTestId}-label`, name_plural)}
            </article>
          );
        })}
      </div>
    </section>
  );

  return <div>Dishtypes!</div>;
}
